var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPokal3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 137 137"
    },
    xmlSpace: "preserve",
    viewBox: "25.08 20.97 86.83 95.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st021345234352{fill:none;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M68.3,79.4L68.3,79.4c-9.4,0-17.5-6.3-19-14.9l-6.1-35.1c0-2.6,2.3-4.8,5.2-4.8h39.7c2.8,0,5.2,2.1,5.2,4.8   l-6.1,35.1C85.8,73.1,77.8,79.4,68.3,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M43.2,34.2h-8.8c-4.4,0-7.1,4.3-4.9,7.8l18.9,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M93.8,34.2h8.8c4.4,0,7.1,4.3,4.9,7.8L88.2,59.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 93.1,
    className: "st021345234352",
    width: 26.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M86.5,104.3H50.2c-2.4,0-4.3,1.9-4.3,4.3v3.8h44.8v-3.8C90.7,106.2,88.8,104.3,86.5,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M55.3,93.1c0,0,8.7-7.9,8.7-13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st021345234352",
    d: "M81.4,93.1c0,0-8.1-7.9-8.1-13.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPokal3);
export default __webpack_public_path__ + "static/media/Icon_Pokal3.72bcc3aed094448a7512243e295f7899.svg";
export { ForwardRef as ReactComponent };